import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

import { RdsFilterType } from '../models/filter/filter-type.model';
import { RdsFilterUtil } from '../utils';

/**
 * Determine the appropraite filter type given a variable
 */
@Pipe({
  name: 'rdsVariableFilterType',
})
export class RdsVariableFilterTypePipe implements PipeTransform {
  transform(variable: Variable | VariableSummary): RdsFilterType {
    return RdsFilterUtil.determineType(variable);
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [RdsVariableFilterTypePipe],
  declarations: [RdsVariableFilterTypePipe],
})
export class RdsVariableFilterTypePipeModule {}
